// Лимиты условий триггера «Ключевые слова во входящем сообщении» робота
// «Установка тега» — дублируют валидацию бэкенда.
export const INCOMING_MESSAGE_KEYWORD_GROUPS_LIMITS = {
  maxGroups: 10,
  maxValuesPerGroup: 50,
  maxValueLength: 200,
};

export type KeywordGroupsLimits = typeof INCOMING_MESSAGE_KEYWORD_GROUPS_LIMITS;
